const FETCH_CURATION = 'curationList/FETCH_CURATION';
const FETCH_INITIAL_SECTION = 'curationList/FETCH_INITIAL_SECTION';
const FETCH_SECTION_CONTENTS = 'curationList/FETCH_SECTION_CONTENTS';
const SET_SECTION_CONTENTS = 'curationList/SET_SECTION_CONTENTS';
const RESET = 'curationList/RESET';

export default {
  FETCH_CURATION,
  FETCH_INITIAL_SECTION,
  FETCH_SECTION_CONTENTS,
  SET_SECTION_CONTENTS,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/curationList/types.js